<template>
    <div class="inline-flex rounded-full items-center px-[10px] py-[4px] mb-[15px] space-x-[10px] text-xs font-bold bg-face-haze text-black">
        <p class="inline-flex text-[12px] space-x-[6px]"><span>{{ name }}</span> <span class="text-face-orange text-semibold text-[12px]" v-if="value.length">{{value}}</span></p>
        <button @click="handleClick" type="button"
                class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-red-400 hover:bg-red-200 hover:text-red-500 focus:outline-none focus:bg-red-500 focus:text-white">
            <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
            </svg>
        </button>
    </div>
</template>
<script setup>
const emit = defineEmits(['remove'])
defineProps({name: String, value: {type: String, default: ''}})

const handleClick = () => {
    emit('remove')
}
</script>
